<template>
    <swiper ref="banner" class="swiper1" :options="bannerOptions">
        <swiper-slide>
            <img src="@/assets/images/customize_01_01.jpg" alt=""/>
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/customize_01_02.jpg" alt=""/>
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/customize_01_03.jpg" alt=""/>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "page1",
    data() {
        return {
            bannerOptions: {
                navigation: {
                    nextEl: '.swiper1 .swiper-button-next',
                },
                direction: 'vertical',
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.banner.$swiper
        }
    },
    components: {
        swiper,
        swiperSlide,
    },
    mounted() {},
    watch: {},
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.swiper1{
    position: absolute;
    width: 100%;
    height: 100%;
    .swiper-button-next{
        width: .55rem;
        height: .37rem;
        background: url('~@/assets/images/customize_next.png') no-repeat 0 0/100%;
        right: auto;
        top: auto;
        margin: 0;
        left: 50%;
        margin-left: -.27rem;
        bottom: 2.8rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
        &::after{
            content: "";
        }
    }
}
</style>